import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import { fromZonedTime } from 'date-fns-tz'
import isAfter from 'date-fns/isAfter'

import it from 'date-fns/locale/it'
import enAU from 'date-fns/locale/en-AU'
import enNZ from 'date-fns/locale/en-NZ'
import enZA from 'date-fns/locale/en-ZA'
import deAT from 'date-fns/locale/de-AT'
import ptBr from 'date-fns/locale/pt-BR'
import pl from 'date-fns/locale/pl'
import de from 'date-fns/locale/de'
import fr from 'date-fns/locale/fr'
import pt from 'date-fns/locale/pt'
import es from 'date-fns/locale/es'
import hu from 'date-fns/locale/hu'
import ro from 'date-fns/locale/ro'
import bg from 'date-fns/locale/bg'
import cs from 'date-fns/locale/cs'
import nl from 'date-fns/locale/nl'
import sk from 'date-fns/locale/sk'

import { env } from '.'

const getDateFnsLocaleObject = localeString => {
  switch (localeString) {
    case 'it':
      return it
    case 'en-AU':
      return enAU
    case 'en-NZ':
      return enNZ
    case 'en-ZA':
      return enZA
    case 'fr':
      return fr
    case 'pt':
      return pt
    case 'pt-BR':
      return ptBr
    case 'es':
      return es
    case 'de':
      return de
    case 'de-AT':
      return deAT
    case 'pl':
      return pl
    case 'hu':
      return hu
    case 'bg':
      return bg
    case 'ro':
      return ro
    case 'cs-CZ':
      return cs
    case 'nl':
      return nl
    case 'sk':
      return sk
    default:
      return enAU
  }
}

const localeString = env('REACT_APP_LANG')
const locale = getDateFnsLocaleObject(localeString)

/**
 * Returns expiration text from a date
 */
const getExpirationText = (endDate, timeZoneName = null) => {
  /**
    if present consider flyer timezone to transform end_date (Date "YYYY-MM-DD") into DateTime,
    otherwise will use device UTC
  */
  const expirationDate = timeZoneName ? fromZonedTime(`${endDate}T23:59:59`, timeZoneName) : new Date(`${endDate}T23:59:59`)
  const now = new Date()

  const expiresOrExpired = isAfter(expirationDate, now)
    ? env('REACT_APP_STRING_EXPIRES')
    : env('REACT_APP_STRING_EXPIRED')
  const distance = formatDistanceToNow(expirationDate, {
    addSuffix: true, locale,
  })

  return `${expiresOrExpired} ${distance}`
}

export default getExpirationText
